module.exports = __webpack_public_path__ + "img/product-smoke-5.7bc5ca9c.jpg";